import { axios } from '@/utils/network'

//post
export function postAction(url, parameter, headers = {}) {
  return axios({
    url: url,
    method:'post',
    data: parameter,
    headers
  })
}

//get
export function getAction(url, parameter, headers = {}) {
  return axios({
    url: url,
    method: 'get',
    params: parameter,
    headers
  })
}

//导出
export function exportAction(url, parameter, headers = {}) {
  return axios({
    url: url,
    method:'post',
    data: parameter,
    responseType:'blob',
    headers
  })
}
//导出
export function exportAction1(url, parameter, headers = {}) {
  return axios({
    url: url,
    method:'post',
    data: parameter,
    responseType:'arraybuffer',
    headers
  })
}

//post method= {post | put}
export function httpAction(url, parameter, method, headers = {}) {
  return axios({
    url: url,
    method:method,
    data: parameter,
    headers
  })
}

//put
export function putAction(url, parameter, headers = {}) {
  return axios({
    url: url,
    method:'put',
    data: parameter,
    headers
  })
}

//get pdf file
export function getFileAction(url, parameter, headers = {}) {
  return axios({
    url: url,
    method: 'get',
    params: parameter,
    timeout: 0,
    headers
  })
}

//deleteAction
export function deleteAction(url, parameter, headers = {}) {
  
  return axios({
    url: url,
    method: 'delete',
    data: parameter,
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url,parameter){
  return axios({
    url: url,
    params: parameter,
    method:'get',
    responseType: 'blob'
  })
}




// WEBPACK FOOTER //
// ./src/api/manage.js